<template>
  <div class="warpConss chat-list">
    <!-- 空列表提示 -->
    <div v-if="courseList.length === 0" class="empty-state">暂无课程内容</div>

    <!-- 课程列表 -->
    <div
      v-else
      v-for="(item, index) in courseList"
      :key="item.id || index"
      class="chat-item"
    >
      <div
        class="item-title"
        :class="{ noLive: isLiveDisabled(item.liveCourseStatus) }"
      >
        <div class="tt-box">
          <div
            class="flex-c ellipsis"
            :class="{ course_title: isTrialAvailable(item) }"
          >
            <div
              @click.stop="getSt(item)"
              class="title ellipsis"
              :class="{ 'lilve-title': item.liveCourseStatus === 1 }"
            >
              <i
                v-if="isLiveDisabled(item.liveCourseStatus)"
                class="iconfont icon-suotou"
              />
              <i v-else class="iconfont icon-a-Union21" />
              {{ item.liveChapterName }}
            </div>
            <div v-if="item.liveCourseStatus === 1" class="liveIng">
              <i class="live iconfont icon-a-Group1339" /> 正在直播中
            </div>
            <span class="time ellipsis">
              <span>
                {{ item.ksTime || 0 }}
                课时
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="but-list">
        <div :class="{ noLives: isLiveDisabled(item.liveCourseStatus) }">
          <div
            v-if="item.whetherAttachment"
            class="keep-learn"
            @click.stop="goData(item, 1)"
          >
            随堂讲义
          </div>
          <div
            v-if="item.whetherPaper"
            class="keep-learn"
            @click.stop="cgeckTask(item)"
          >
            随堂测试
          </div>
          <div
            v-if="item.whetherMeans"
            class="keep-learn"
            @click.stop="goData(item, 2)"
          >
            随堂资料
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="45%" :visible.sync="questionBankVisible">
      <div v-if="detalilsList&&detalilsList.limitPlayLink" class="player-main">
        <jxyplayer
          :url="detalilsList.limitPlayLink"
          :options="option"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { getInfo } from "@/api/cookies";
import jxyplayer from "@/components/jxyPlay.vue";

export default {
  components: {
    jxyplayer,
  },
  name: "chaterxbkbot",
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
    classId: {
      type: [String, Number],
      default: "",
    },
    courseId: {
      type: [String, Number],
      default: "",
    },
    // 是否购买
    IsPurchase: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * 计算课程列表，确保返回有效的数组
     */
    courseList() {
      return Array.isArray(this.list) ? this.list : [];
    },
  },
  data() {
    return {
      userInfo: null,
      option: {
        width: "100%",
        height: "100%",
        type: "HLS",
        aDType: "swiper",
      },
      questionBankVisible: false,
    };
  },

  created() {
    this.userInfo = getInfo();
  },
  methods: {
    isLiveDisabled(status) {
      return status === 0 || status === 2;
    },
    getSt(item) {
      console.log(item, "item");
      if (item.limitPlayLink) {
        this.questionBankVisible = true;
        this.detalilsList = item; 
      }
    },
    isTrialAvailable(item) {
      // return item.limitPlayLink;
    },

    cgeckTask(item) {
      if (!this.IsPurchase) {
        this.$notify({
          title: "提示",
          message: "您还没有购买!",
          type: "warning",
        });
        return;
      }
      Vue.prototype.goExam({ contactId: item.paperId, examType: 6 });
    },

    goData(item, type) {
      // 优先使用组件内部缓存的用户信息
      if (!this.userInfo) {
        this.userInfo = getInfo();
        if (!this.userInfo) {
          Vue.prototype.goLoginView && Vue.prototype.goLoginView(false);
          return;
        }
      }
      console.log(this.IsPurchase, "this.IsPurchase");

      // 检查是否购买
      if (!this.IsPurchase) {
        this.$notify({
          title: "提示",
          message: "您还没有购买!",
          type: "warning",
        });
        return;
      }

      try {
        const params = new URLSearchParams({
          type: type,
          ChatId: item.liveChapterId,
          courseId: this.courseId,
        });
        window.open(`/data/dataPackageDetail?${params.toString()}`, "_blank");
      } catch (error) {
        console.error("打开资料详情失败:", error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
// 容器样式
.warpConss {
  width: 100%;
  height: auto;
}

// 聊天列表样式
.chat-list {
  padding: 0 32px;

  // 聊天项样式
  .chat-item {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    background: #f6f6f6;
    margin-bottom: 10px;

    &:first-child {
      margin-top: 20px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    // 项目标题样式
    .item-title {
      width: calc(100% - 300px);
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: space-between;

      .tt-box {
        width: 100%;
      }

      // 直播标题高亮
      .lilve-title {
        color: #ff5e51 !important;
      }

      // 标题文本样式
      .title {
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }

      // 图标样式
      .iconfont {
        font-size: 14px;
        margin-right: 6px;
      }

      // 时间标签样式
      .time {
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
        background: #ffffff;
        padding: 2px 6px;
        margin-left: 10px;
      }

      // 直播中标签
      .liveIng {
        padding: 0 4px;
        height: 20px;
        background: #ff5e51;
        border-radius: 4px;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 8px;

        .live {
          color: #fff;
          font-size: 12px;
          margin-right: 4px;
        }
      }
    }

    // 未开始/生成中状态样式
    .noLive {
      color: #9fa4ad;

      .title,
      .time {
        color: #9fa4ad !important;
      }
    }

    // 未开始状态下的按钮样式
    .noLives {
      .keep-learn {
        border: 1px solid #dddddd;
        border-radius: 4px;
        color: #aaaaaa;
      }
    }

    // 按钮列表样式
    .but-list {
      flex-shrink: 0;
      display: flex;
      width: 300px;
      justify-content: flex-end;

      // 操作按钮样式
      .keep-learn {
        margin-right: 10px;
        flex-shrink: 0;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

// 可试听标记样式
.course_title::after {
  content: "可试听";
  display: inline-block;
  width: 48px;
  height: 20px;
  color: #ff5e51;
  background-color: #ffedeb;
  border-radius: 2px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin-left: 20px;
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}
.player-main{
  height: 600px;
}
</style>
